interface Props {
  onClick: () => void
}

export function CloseButton({ onClick }: Props) {
  const icon = (
    <svg xmlns="http://www.w3.org/2000/svg" width="75" height="75" viewBox="0 0 50 50">
      <path
        opacity=".4"
        fill="%23666E6E"
        scale="2.5"
        d="M35.6 34.4L28 26.8l7.6-7.6c.2-.2.2-.5 0-.7l-.5-.5c-.2-.2-.5-.2-.7 0l-7.6 7.6-7.5-7.6c-.2-.2-.5-.2-.7 0l-.6.6c-.2.2-.2.5 0 .7l7.6 7.6-7.6 7.5c-.2.2-.2.5 0 .7l.5.5c.2.2.5.2.7 0l7.6-7.6 7.6 7.6c.2.2.5.2.7 0l.5-.5c.2-.2.2-.5 0-.7z"
      />
    </svg>
  )

  return (
    <button className={tailwind.closeButton} onClick={onClick}>
      {icon}
    </button>
  )
}

const tailwind = {
  closeButton: 'flex text-4xl text-white items-center cursor-pointer fixed right-1 top-1 z-50',
}
